export const SEND_TWEETS_TO_STORE = 'SEND_TWEETS_TO_STORE'
export const DELETE_TWEET_OF_STORE = 'DELETE_TWEET_OF_STORE'
